// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"358ae11f","156":"5270081a","206":"493f9ef4","324":"70ffa59c","424":"46a2e3ac","830":"01575440"}[chunkId] + ".chunk.css";
};